import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router';
import { BarnyardIcon } from 'barnyard/icons';
import { Count } from 'barnyard/components';
import AlertItem from './AlertItem';
import InvoiceNotGlCodedTable from './InvoiceNotGlCodedTable';


const InvoiceNotGlCodedAlert = ({ alert, ...other }) => {
  const totalCount = alert.value.count;
  return (
    <AlertItem
      alert={alert}
      date={moment(alert.date).format('MMMM Do, YYYY')}
      icon={<BarnyardIcon icon={['fa', 'file-invoice-dollar']} className='DiscussCard__replyIcon' />}
      title={(
        <div>
          <strong>
            <Count count={totalCount} singular='invoice' /> {' '}
          </strong> created {' '}
          <strong>
            {alert.value.number_days}
          </strong>
          {' '} or more days ago {totalCount > 1 ? 'have' : 'has' } items without gl codes
          <div>
            <Link to='/corporate/invoices/invoices/?glcode=0'>
              View Invoices <BarnyardIcon icon={['fal', 'angle-right']} />
            </Link>
          </div>
        </div>
      )}
      content={(
        <InvoiceNotGlCodedTable
          includeExport={true}
          invoices={alert.value.invoices}
        />
      )}
      {...other}
    />
  );
};

InvoiceNotGlCodedAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default InvoiceNotGlCodedAlert;
